import React, { useState } from "react";
import { Modal } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import StoreOptions from "./StoreOptions";
import { isInsideApp } from "./env";
import styles from "./styles.module.css";

const DownloadAppButton = () => {
  const [open, setOpen] = useState(false);

  if (isInsideApp()) return null;

  return (
    <>
      <div className="d-flex align-items-center justify-content-center mt-2">
        <button
          type="button"
          className={styles.downloadBtn}
          onClick={() => setOpen(true)}
        >
          <DownloadOutlined style={{ fontSize: 22 }} />
          <span className={styles.downloadBtnText}>
            <small>دریافت اپلیکیشن</small>
            <strong>اندروید و iOS</strong>
          </span>
        </button>
      </div>

      <Modal
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        centered
        width={620}
        title={
          <span>
            <DownloadOutlined className="ms-2" />
            دریافت اپلیکیشن تسکامون
          </span>
        }
      >
        <StoreOptions />
      </Modal>
    </>
  );
};

export default DownloadAppButton;
